(ns practitest.frontend.active-sessions.events
  (:require
   [ajax.core :as ajax]
   [practitest.frontend.common.i18n :refer [get-translation]]
   [practitest.frontend.components.notifications :as notifications]
   [practitest.frontend.routing.backend-routes :as broutes]
   [re-frame.core :as re-frame]))

(defn account-id [db]
  (get-in db [:current-account :id]))

(re-frame/reg-event-db
 ::initialize
 (fn [db [_ config]]
   (update db :active-sessions merge
           {:sessions (get config :active_sessions [])
            :total-licenses (get config :total_licenses 0)
            :used-licenses (get config :used_licenses 0)})))

(re-frame/reg-event-db
 ::init-complete
 (fn [db _]
   (assoc-in db [:active-sessions :init-complete?] true)))

(re-frame/reg-event-fx
 ::terminate-session
 (fn [{:keys [db]} [_ user-id]]
   {:http-xhrio {:method :post
                 :uri (broutes/get-url "account/accounts#terminate_user_session" {:account_id (account-id db)})
                 :params {:user_id user-id}
                 :format (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success [::terminate-session-success]
                 :on-failure [::terminate-session-error]}}))

(re-frame/reg-event-fx
 ::terminate-session-success
 (fn [{:keys [db]} [_ _response]]
   {:db db
    :dispatch-n [[::notifications/success2
                  (get-translation "active-sessions.terminate-session.success"
                                   "Session terminated successfully")]
                 [::refresh-sessions]]}))

(re-frame/reg-event-fx
 ::refresh-sessions
 (fn [{:keys [db]} [_ _]]
   {:http-xhrio {:method :get
                 :uri (broutes/get-url "account/accounts#active_sessions_data" {:account_id (account-id db)})
                 :params {}
                 :format (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :on-success [::initialize]
                 :on-failure [::refresh-sessions-error]}}))

(re-frame/reg-event-fx
 ::refresh-sessions-error
 (fn [{:keys [db]} [_ _error]]
   {:db db
    :dispatch [::notifications/error2
               (get-translation "active-sessions.refresh-sessions.error"
                                "Failed to refresh sessions")]}))

(re-frame/reg-event-fx
 ::terminate-session-error
 (fn [{:keys [db]} [_ _error]]
   {:db db
    :dispatch [::notifications/error2
               (get-translation "active-sessions.terminate-session.error"
                                "Failed to terminate session")]}))
